import { QuestionBase } from "./question-base.model";

export class InputButtonQuestion extends QuestionBase<string> {
    controlType = 'textbox-button';
    type: string;
    resource: string;
    visible: any;
    btnText: any;
    button: any
    value: any;
    buttons_config: any;
    hint: string;
    constructor(options: {} = {}) {
        super(options);
        this.type = options['type'] || '';
        this.resource = options['resource'] || '';
        this.visible = options['visible'] || "true";
        this.btnText = options['btnText'] || "Click";
        this.value = options['value'] || null;
        this.button = options['button'] || null;
        this.buttons_config = options.hasOwnProperty('buttons_config') ? options['buttons_config'] : null;
        this.hint = options['hint'] || "";
    }
}
